import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";
import MyListingListItem from "./list-item";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { useNavigate } from "react-router-dom";
import { deleteEquipment } from "slices/dashboardReducer";

const MyListingList = ({ list, setReloadList }: any) => {
  const { dashboardReducer } = useAppSelector((state) => state);
  const { loading }: any = dashboardReducer;
  const [deleteId, setDeleteId] = useState(0);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const deleteTheEquipment = () => {
    dispatch(
      deleteEquipment({
        id: deleteId,
        callback: () => {
          setDeleteId(0);
          setReloadList();
        },
      })
    );
  };
  if (!loading && list.length === 0) {
    return (
      <Box
        sx={{
          mx: "4%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          width: "100%",
          my: "8%",
        }}
      >
        <img src="/assets/img/icons/listing_empty.svg" alt="" width="305px" />
        <Typography
          sx={{
            color: "#323232",
            fontWeight: 700,
            fontSize: "26px",
            lineHeight: "31px",
            mt: "20px",
            mb: "10px",
            textAlign: "center",
          }}
        >
          No Equipments Added in Listing Yet!
        </Typography>
        <Typography
          sx={{
            color: "#A2A2A2",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            mb: "15px",
            textAlign: "center",
          }}
        >
          You haven't added any equipment yet! Start by adding equipment to your
          listing.
        </Typography>

        <Button
          variant="contained"
          sx={{
            borderRadius: "10px",
            height: "56px",
            mt: "15px",
            width: "200px",
          }}
          onClick={() => {
            navigate("/list-equipment");
          }}
        >
          Add New Listing
        </Button>
      </Box>
    );
  }

  if (loading) {
    return (
      <Grid container spacing={3}>
        {[1, 2, 3, 4, 5, 6].map(() => (
          <Grid item md={3} lg={3} xl={3} sm={6} xs={6}>
            <Skeleton
              variant="rectangular"
              sx={{ height: "350px", width: "100%", borderRadius: "10px" }}
            />
          </Grid>
        ))}
      </Grid>
    );
  }
  return (
    <Grid container spacing={3}>
      {list.map((d: any) => (
        <Grid item md={3} lg={3} xl={3} sm={6} xs={6}>
          <MyListingListItem {...d} setDeleteId={setDeleteId} />
        </Grid>
      ))}

      {deleteId > 0 && (
        <Dialog
          open
          onClose={() => setDeleteId(0)}
          PaperProps={{ style: { padding: "20px", borderRadius: "20px" } }}
        >
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogContent>
            <Typography>
              You want to delete this Listing, This action cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="outlined"
              sx={{ borderRadius: "10px", height: "48px" }}
              fullWidth
              onClick={() => setDeleteId(0)}
            >
              Cancel
            </Button>

            <Button
              color="error"
              variant="contained"
              sx={{ borderRadius: "10px", height: "48px" }}
              fullWidth
              onClick={deleteTheEquipment}
            >
              Yes Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Grid>
  );
};

export default MyListingList;
